module.exports = __webpack_public_path__ + "assets/img/download_zoom.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/download_zoom.png
// module id = 1939
// module chunks = 0